<template>
  <div
    :class="
      navigation || culturePop
        ? 'popup'
        : '' || startProjectPop || recruitPop
        ? 'popup black'
        : '' || awardsPop
        ? 'black-gra'
        : ''
    "
    class="container viewPage ssWellsView"
  >
    <header-area />

    <div class="worksView" :class="readyAction ? 'ready-action' : ''">
      <div class="contsBox">
        <div class="viewInCon">
          <div class="workTopTitle">
            <div class="workSlogan web">
              Cook the healthy life! <br />For healthier and happier our daily lives.
            </div>
            <div class="workSlogan mobile">
              Cook the healthy life! <br />For healthier and happier our daily lives.
            </div>
            <div class="workTopDay">
              <p>플립커뮤니케이션즈, 삼성웰스토리 미디어 플랫폼 구축</p>
              <ul>
                <li>PC / Mobile web</li>
                <li>2021.11.16</li>
              </ul>
            </div>
            <div class="workTopSns">
              <a href="https://www.story-g.co.kr" target="_blank" class="siteAddr"
                >https://www.story-g.co.kr</a
              >
              <ul>
                <li>
                  <social-sharing
                    url="https://www.pulip.com/sns/samsungWells"
                    title="브랜드를 넘어 이야기를 담다."
                    hashtags="플립커뮤니케이션즈,삼성웰스토리"
                    twitter-user="플립커뮤니케이션즈"
                    inline-template
                  >
                    <network network="facebook">
                      <a href="javascript:;" class="wFacebook">
                        <img src="@/assets/images/@sns_fb_w.png" alt="" />
                      </a>
                    </network>
                  </social-sharing>
                </li>
                <li>
                  <social-sharing
                    url="https://www.pulip.com/sns/samsungWells"
                    title="브랜드를 넘어 이야기를 담다."
                    hashtags="플립커뮤니케이션즈,삼성웰스토리"
                    twitter-user="플립커뮤니케이션즈"
                    inline-template
                  >
                    <network network="twitter">
                      <a href="javascript:;" class="wTweeter">
                        <img src="@/assets/images/@sns_tw_w.png" alt="" />
                      </a>
                    </network>
                  </social-sharing>
                </li>
                <li>
                  <a href="javascript:;" @click.prevent="doCopy" class="wChain">
                    <img src="@/assets/images/@web_link_w.png" alt="" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="workVisual">
        <div class="workImg">
          <span class="workMoveTxt"
            ><marquee-text :duration="15"
              >&nbsp;Cook the healthy life! For healthier and happier our daily lives.</marquee-text
            ></span
          >
          <img class="web" src="@/assets/images/works_view/ssWells/ssWells_visual.jpg" alt="" />
          <img
            class="mobile"
            src="@/assets/images/works_view/ssWells/ssWells_visual_m.jpg"
            alt=""
          />
        </div>
      </div>
    </div>

    <kinesis-container event="scroll">
      <div class="wideConts ssWellsLayer">
        <div class="ssWellsBox">
          <div class="worksView">
            <div
              class="video"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <video
                id="ssWellsMovie1"
                playsinline
                muted="muted"
                autoplay="autoplay"
                preload="auto"
                loop="loop"
                poster="@/assets/images/works_view/ssWells/scroll_action1_1.png"
              >
                <source src="@/assets/images/works_view/ssWells/video_01.mp4" type="video/mp4" />
              </video>
            </div>
            <div
              class="topInfo"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <p>
                Establishment<br class="mobile" />
                a platform in <br class="web" />response<br class="mobile" />
                to trend of <br class="mobile" />food service market
              </p>
            </div>
            <div
              class="ssWellsHistory"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="top">
                <span class="logoWells"
                  ><img src="@/assets/images/works_view/ssWells/ssWells_logo.png" alt=""
                /></span>
              </div>
              <div class="txt">
                <p>
                  소소하게 맛집을 찾거나 배달 음식을 주문하고 <br class="web" />먹방을 보는 등
                  식문화에 대한 관심이 높아지고 있습니다. <br class="web" />이에 삼성웰스토리는
                  다양한 형태로 확장되고 있는 푸드 서비스 <br class="web" />시장에 대응할 수 있는
                  플랫폼의 필요성을 인식하고 <br class="web" />새로운 형태의 미디어 플랫폼을
                  만들었습니다.
                </p>
              </div>
            </div>
            <div
              class="ssWellsCombine"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="barGroup">
                <div>Media<br />platform</div>
              </div>
              <div class="roundGroup"><span>Webzine</span></div>
              <div class="roundGroup">
                <span>Social<br />media</span>
              </div>
              <div class="roundGroup"><span>News</span></div>
              <div class="barGroup">
                <div>B2B<br /><span>Business to Business</span></div>
              </div>
            </div>
            <div class="ssWellsValue">
              <div
                class="txtWrap"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                <div class="titleCnt">
                  <span class="title">STORY.G <br />CORE VALUE</span>
                </div>
                <div class="txtCnt">
                  <div class="txt right">
                    <p class="enSub">
                      Make it easy, comfortable, and fun for anyone <br class="web" />to get the
                      stories and useful information of Samsung Welstory <br class="web" />which has
                      been dispersed in many different media.
                    </p>
                    <p>
                      다양한 미디어에 산재했던 삼성웰스토리의 이야기와 유용한 정보를
                      <br class="web" />누구나 쉽고 편하고 재미있게 얻어 갈 수 있도록 구성했습니다.
                    </p>
                  </div>
                  <div class="txt">
                    <p>
                      식문화를 선도하고 이를 중심으로 라이프스타일에 <br />새로운 이야기를 더해가는
                      삼성웰스토리만의 <br />차별화된 브랜드 아이덴티티를 형성하고자 했습니다
                    </p>
                  </div>
                </div>
              </div>
              <div
                class="valueAct"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                <div class="valueActGroup">
                  <div class="groupBox">
                    <div class="roundBox">삼성웰스토리의 <br />모든 이야기와 <br />히스토리</div>
                    <span class="value">Story</span>
                  </div>
                  <div class="groupBox">
                    <div class="roundBox">
                      이용 고객 및 <br />잠재 고객이 <br />쉽게 인지할 수 있는 <br />경험을 제공
                    </div>
                    <span class="value">Experience</span>
                  </div>
                  <div class="groupBox">
                    <div class="roundBox">
                      건강하고 맛있는 <br />식문화와 관련된 <br />다양한 이야기와 <br />정보에 연결
                    </div>
                    <span class="value">Connection</span>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="ssWellsBrand"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="txtWrap">
                <div class="titleCnt">
                  <span class="title">STORY.G <br />BRAND STRATEGY</span>
                </div>
              </div>
              <div class="brandStrategy active">
                <div class="brandActGroup">
                  <div class="brandBox">
                    <p>Food culture<span class="subT">를 담다</span></p>
                  </div>
                  <div class="brandBox">
                    <p>Story<span class="subT">를 담다</span></p>
                  </div>
                  <div class="brandBox">
                    <p>Lifestyle<span class="subT">을 담다</span></p>
                  </div>
                  <div class="brandBox">
                    <p>Health<span class="subT">를 담다</span></p>
                  </div>
                  <div class="txtBox">
                    <p>
                      식문화를 중심으로 라이프 스타일과 건강에 새로운 이야기를 더해<span
                        class="subT"
                        >다양한 볼거리와 즐길 거리를 담습니다</span
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="video"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <video
                id="ssWellsMovie2"
                playsinline
                muted="muted"
                autoplay="autoplay"
                preload="auto"
                loop="loop"
                poster="@/assets/images/works_view/ssWells/scroll_action1_1.png"
              >
                <source src="@/assets/images/works_view/ssWells/video_02.mp4" type="video/mp4" />
              </video>
            </div>
            <div
              class="ssWellsDesign"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="txtWrap">
                <div class="titleCnt">
                  <span class="title">STORY.G <br />CONTENTS DESIGN <br />STRATEGY</span>
                </div>
              </div>
              <div class="designStrategy active">
                <div class="roundEdition">
                  <div class="roundBox">Contents</div>
                  <div class="roundBox">Campaign</div>
                  <span class="bar"></span>
                  <div class="roundBox">Welstory</div>
                </div>
                <div class="subTxtWrap">
                  <div>
                    <span class="title">STORY.G</span>
                    <em>Message</em>
                    <p>
                      콘텐츠와 캠페인을 통해 어떤 메시지를 전달할 것인가? <br class="web" />기존
                      웹진이나 유튜브가 삼성웰스토리의 이야기를 전달했다면, <br class="web" />미디어
                      플랫폼 Story.G 에서는 삼성웰스토리의 방향성과 관심사를
                      <br class="web" />확장하고자 하는 이야기에 초점을 맞췄습니다.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="ssWellsKeyword">
              <div class="swiper-container">
                <div class="swiper-wrapper">
                  <div class="swiper-slide">
                    <span class="num">Keyword 1</span>
                    <div class="img">
                      <img src="@/assets/images/works_view/ssWells/keyword_slide_1.jpg" alt="" />
                    </div>
                    <div class="keywordValue">
                      <span class="valueTilte">제철 In season</span>
                      <p>신선하고 건강한 제철 식자재를 <br />유통하고 선보이는 브랜드</p>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <span class="num">Keyword 2</span>
                    <div class="img">
                      <img src="@/assets/images/works_view/ssWells/keyword_slide_2.jpg" alt="" />
                    </div>
                    <div class="keywordValue">
                      <span class="valueTilte">한끼 A meal</span>
                      <p>
                        영양가 높으면서도 다양하고 트렌디한 <br />한끼로 식문화를 선도하는 브랜드
                      </p>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <span class="num">Keyword 3</span>
                    <div class="img">
                      <img src="@/assets/images/works_view/ssWells/keyword_slide_3.jpg" alt="" />
                    </div>
                    <div class="keywordValue">
                      <span class="valueTilte">식문화 Food culture</span>
                      <p>
                        건강한 식문화를 통해 새로운 라이프 <br />스타일을 제시하고 만들어가는 브랜드
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="ssWellsStory"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="txtWrap">
                <div class="titleCnt">
                  <span class="title">STORY.G <br />CONTENTS DESIGN <br />STRATEGY</span>
                </div>
                <p>
                  삼성웰스토리는 고객의 건강과 행복을 향해 있습니다. <br />매일의 일상에서 스며들듯
                  자연스럽게 함께하는 식사 공간에서 <br class="web" />언제나 유쾌하게 고객의 진정한
                  건강과 행복을 열어 갑니다.
                </p>
              </div>
              <div class="swiper-container">
                <div class="swiper-wrapper">
                  <div class="swiper-slide">
                    <div class="img">
                      <img src="@/assets/images/works_view/ssWells/story_slide_1.jpg" alt="" />
                    </div>
                    <div class="imgOn">
                      <img src="@/assets/images/works_view/ssWells/story_slide_1_on.jpg" alt="" />
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="img">
                      <img src="@/assets/images/works_view/ssWells/story_slide_2.jpg" alt="" />
                    </div>
                    <div class="imgOn">
                      <img src="@/assets/images/works_view/ssWells/story_slide_2_on.jpg" alt="" />
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="img">
                      <img src="@/assets/images/works_view/ssWells/story_slide_3.jpg" alt="" />
                    </div>
                    <div class="imgOn">
                      <img src="@/assets/images/works_view/ssWells/story_slide_3_on.jpg" alt="" />
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="img">
                      <img src="@/assets/images/works_view/ssWells/story_slide_4.jpg" alt="" />
                    </div>
                    <div class="imgOn">
                      <img src="@/assets/images/works_view/ssWells/story_slide_4_on.jpg" alt="" />
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="img">
                      <img src="@/assets/images/works_view/ssWells/story_slide_5.jpg" alt="" />
                    </div>
                    <div class="imgOn">
                      <img src="@/assets/images/works_view/ssWells/story_slide_5_on.jpg" alt="" />
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="img">
                      <img src="@/assets/images/works_view/ssWells/story_slide_6.jpg" alt="" />
                    </div>
                    <div class="imgOn">
                      <img src="@/assets/images/works_view/ssWells/story_slide_6_on.jpg" alt="" />
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="img">
                      <img src="@/assets/images/works_view/ssWells/story_slide_7.jpg" alt="" />
                    </div>
                    <div class="imgOn">
                      <img src="@/assets/images/works_view/ssWells/story_slide_7_on.jpg" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="ssWellsUiUx"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="titleCntF">
                <span class="title">STORY.G <br />UI/UX STRATEGY</span>
              </div>
              <div class="txtWrap">
                <div class="titleCnt">
                  <span class="title">MAIN UI</span>
                </div>
                <p>
                  고객과의 접점이 시작되는 메인 페이지에서는 <br class="web" />새로운 콘텐츠와
                  캠페인이 출시될 경우, 해당 페이지와 <br class="web" />연결해 자연스러운 탐색이
                  가능하도록 설계하였습니다. <br />이를 통해 삼성웰스토리를 처음 접하는 고객도
                  <br class="web" />쉽게 브랜드를 이해할 수 있습니다.
                </p>
              </div>
              <div class="mainPcVer">
                <div class="storySwiper swiper-container">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide">
                      <div class="img">
                        <img
                          src="@/assets/images/works_view/ssWells/main_story_slide1.jpg"
                          alt=""
                        />
                      </div>
                      <span class="unit">Growing</span>
                      <p>빵 맛의 기본기, 빵부심은 어디? <br />바로 요기~</p>
                    </div>
                    <div class="swiper-slide">
                      <div class="img">
                        <img
                          src="@/assets/images/works_view/ssWells/main_story_slide2.jpg"
                          alt=""
                        />
                      </div>
                      <span class="unit">Gourmet</span>
                      <p>게임을 시작하지, <br />우선 밥부터 먹고</p>
                    </div>
                    <div class="swiper-slide">
                      <div class="img">
                        <img
                          src="@/assets/images/works_view/ssWells/main_story_slide3.jpg"
                          alt=""
                        />
                      </div>
                      <span class="unit">Ground</span>
                      <p>낮과 밤이 다른 브런치 펍 <br />더몰트하우스</p>
                    </div>
                    <div class="swiper-slide">
                      <div class="img">
                        <img
                          src="@/assets/images/works_view/ssWells/main_story_slide4.jpg"
                          alt=""
                        />
                      </div>
                      <span class="unit">Go ESG</span>
                      <p>밥 짓는 기업의 ESG, <br />WELL 365</p>
                    </div>
                    <div class="swiper-slide">
                      <div class="img">
                        <img
                          src="@/assets/images/works_view/ssWells/main_story_slide5.jpg"
                          alt=""
                        />
                      </div>
                      <span class="unit">Growing</span>
                      <p>베트남에서도 건강한 식음 문화를 <br />선도합니다</p>
                    </div>
                    <div class="swiper-slide">
                      <div class="img">
                        <img
                          src="@/assets/images/works_view/ssWells/main_story_slide6.jpg"
                          alt=""
                        />
                      </div>
                      <span class="unit">Gourmet</span>
                      <p>프라이팬에 고기, 해산물, 채소 넣은 <br />파에야</p>
                    </div>
                    <div class="swiper-slide">
                      <div class="img">
                        <img
                          src="@/assets/images/works_view/ssWells/main_story_slide7.jpg"
                          alt=""
                        />
                      </div>
                      <span class="unit">Go green</span>
                      <p>스스로 만드는 환경 사랑 실천 방법</p>
                    </div>
                  </div>
                </div>
                <div class="mediaSwiper swiper-container">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide">
                      <div class="img">
                        <img
                          src="@/assets/images/works_view/ssWells/main_media_slide1.jpg"
                          alt=""
                        />
                      </div>
                      <p>비로소, <br />여행의 그 깊이를 깨닫다</p>
                    </div>
                    <div class="swiper-slide">
                      <div class="img">
                        <img
                          src="@/assets/images/works_view/ssWells/main_media_slide2.jpg"
                          alt=""
                        />
                      </div>
                      <p>이런 떡뽁기 먹어 봤니? <br />매콤 달콤의 끝판왕</p>
                    </div>
                    <div class="swiper-slide">
                      <div class="img">
                        <img
                          src="@/assets/images/works_view/ssWells/main_media_slide3.jpg"
                          alt=""
                        />
                      </div>
                      <p>이런빵 먹어 봤니? <br />못먹어 봤으면 말을 말어~</p>
                    </div>
                    <div class="swiper-slide">
                      <div class="img">
                        <img
                          src="@/assets/images/works_view/ssWells/main_media_slide4.jpg"
                          alt=""
                        />
                      </div>
                      <p>경영 관리 보고서 <br />업체 최초 도입</p>
                    </div>
                    <div class="swiper-slide">
                      <div class="img">
                        <img
                          src="@/assets/images/works_view/ssWells/main_media_slide5.jpg"
                          alt=""
                        />
                      </div>
                      <p>감자는 강원도 감자 한번 맛 <br />보시겠어요?</p>
                    </div>
                    <div class="swiper-slide">
                      <div class="img">
                        <img
                          src="@/assets/images/works_view/ssWells/main_media_slide6.jpg"
                          alt=""
                        />
                      </div>
                      <p>된장엔 꽃게~ <br />양양 꽃게 먹으로 GOGO~</p>
                    </div>
                    <div class="swiper-slide">
                      <div class="img">
                        <img
                          src="@/assets/images/works_view/ssWells/main_media_slide7.jpg"
                          alt=""
                        />
                      </div>
                      <p>바리스타의 꿈을 꾸다 <br />최바리스타!</p>
                    </div>
                    <div class="swiper-slide">
                      <div class="img">
                        <img
                          src="@/assets/images/works_view/ssWells/main_media_slide8.jpg"
                          alt=""
                        />
                      </div>
                      <p>집에서 선인장을 키우는 <br />올바른 방법!!!</p>
                    </div>
                    <div class="swiper-slide">
                      <div class="img">
                        <img
                          src="@/assets/images/works_view/ssWells/main_media_slide9.jpg"
                          alt=""
                        />
                      </div>
                      <p>열정 한바가지에 재능 한스푼이면 <br />만사 오케이~</p>
                    </div>
                    <div class="swiper-slide">
                      <div class="img">
                        <img
                          src="@/assets/images/works_view/ssWells/main_media_slide10.jpg"
                          alt=""
                        />
                      </div>
                      <p>스케이트 보드를 타고, <br />밥 묵자~</p>
                    </div>
                    <div class="swiper-slide">
                      <div class="img">
                        <img
                          src="@/assets/images/works_view/ssWells/main_media_slide11.jpg"
                          alt=""
                        />
                      </div>
                      <p>육수 한 국자면 세상없는 <br />새로운 맛이 탄생한다.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="txtWrap2"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                <div class="titleCnt">
                  <span class="title">CONTENTS UI</span>
                </div>
                <p>
                  웹진, 소셜 미디어, 뉴스 등의 다양한 콘텐츠를 <br class="web" />메뉴별로 엮어 쉽게
                  접근할 수 있게 구성했습니다. <br />또한 카테고리마다 콘텐츠별 특징을 고려해
                  <br class="web" />사용자가 더욱 흥미롭게 콘텐츠를 볼 수 있도록 설계했습니다.
                </p>
              </div>
              <div
                class="contentsUi"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                <ul>
                  <li>
                    <img src="@/assets/images/works_view/ssWells/content_pc_ui1.jpg" alt="" />
                    <div class="explain">
                      <strong>diversity</strong>
                      <p>각 카테고리별 특성과 내용에 따라 <br />차별화, 다양화 한 UI</p>
                    </div>
                  </li>
                  <li>
                    <img src="@/assets/images/works_view/ssWells/content_pc_ui2.jpg" alt="" />
                  </li>
                  <li>
                    <img src="@/assets/images/works_view/ssWells/content_pc_ui3.png" alt="" />
                  </li>
                  <li>
                    <img src="@/assets/images/works_view/ssWells/content_pc_ui4.png" alt="" />
                  </li>
                </ul>
              </div>
            </div>
            <div
              class="ssWellsMoUi"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="txtWrap">
                <div class="titleCnt">
                  <span class="title">STORY.G<br />MOBILE UI</span>
                </div>
                <p>
                  PC에서의 정보 탐색 경험을 모바일을 비롯해 <br />다양한 디바이스 환경에서 일관성
                  있게 제공했습니다.
                </p>
              </div>
              <div class="mobileUi">
                <ul>
                  <li>
                    <img src="@/assets/images/works_view/ssWells/content_mo_ui1.png" alt="" />
                  </li>
                  <li>
                    <img src="@/assets/images/works_view/ssWells/content_mo_ui2.png" alt="" />
                    <div class="explain">
                      <strong>CARD LIST</strong>
                      <p>모바일 환경에 최적화된 <br />카드 리스트 형태</p>
                    </div>
                  </li>
                  <li>
                    <img src="@/assets/images/works_view/ssWells/content_mo_ui3.png" alt="" />
                  </li>
                  <li>
                    <div class="imgBox">
                      <img src="@/assets/images/works_view/ssWells/content_mo_ui4.png" alt="" />
                    </div>
                    <div class="imgBox">
                      <img src="@/assets/images/works_view/ssWells/content_mo_ui5.png" alt="" />
                    </div>
                    <div class="explain web">
                      <strong>consistency</strong>
                      <p>PC 환경에서와의 UX의 통일성과 <br />UI 톤앤매너를 일관성 있게 유지</p>
                    </div>
                  </li>
                  <li>
                    <img src="@/assets/images/works_view/ssWells/content_mo_ui6.png" alt="" />
                    <div class="explain mobile">
                      <strong>consistency</strong>
                      <p>
                        PC 환경에서와의<br />
                        UX의 통일성과 <br />UI 톤앤매너를<br />
                        일관성 있게 유지
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div
              class="ssWellsSearch"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="txtWrap">
                <div class="titleCnt">
                  <span class="title">STORY.G<br />KEYWORD & SEARCH</span>
                </div>
                <p>
                  고객이 관심 있는 콘텐츠와 캠페인을 쉽게 볼 수 있도록 <br class="web" />추천
                  키워드를 배치하고 통합검색 기능을 구현했습니다.
                </p>
              </div>
              <div class="swiperSearch swiper-container">
                <div class="swiper-wrapper">
                  <div class="swiper-slide">
                    <div class="img">
                      <img src="@/assets/images/works_view/ssWells/search_slide_1.png" alt="" />
                    </div>
                    <div class="searchValue">
                      <span class="valueTilte">KEYWORD</span>
                      <p>PC/Wide view에서 추천 키워드로 <br />바로 접근 가능한 UI 제공</p>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="img">
                      <img src="@/assets/images/works_view/ssWells/search_slide_2.png" alt="" />
                    </div>
                    <div class="searchValue">
                      <span class="valueTilte">SEARCH</span>
                      <p>통합 검색 기능과 함께 <br />콘텐츠 키워드 검색 기능 탑재</p>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="img">
                      <img src="@/assets/images/works_view/ssWells/search_slide_3.png" alt="" />
                    </div>
                    <div class="searchValue">
                      <span class="valueTilte">SEARCH RESULT</span>
                      <p>해당 키워드 및 검색 내용에 따라 <br />카테고리 별 주요 콘텐츠 검색</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="ssWellsEnd">
        <div class="contsBox">
          <div class="endTitle">
            Cook the healthy life! <br />For healthier and happier our daily lives.
          </div>
          <p>
            소소하게 맛집을 찾거나 배달 음식을 주문하고 먹방을 보는 등 식문화에 대한 관심이 높아지고
            있습니다.<br />이에 다양한 형태로 확장되고 있는 푸드 서비스 시장에 대응할 수 있는
            플랫폼의 필요성을 인식하고 새로운 형태의 미디어 플랫폼을 만들었습니다.
          </p>
          <a href="https://www.pulinpinc.com/contact" target="_blank"
            >디지털 트랜스포메이션 더 알아보기</a
          >
        </div>
      </div>
    </kinesis-container>

    <div class="worksView">
      <div class="contsBox">
        <div class="backToList">
          <router-link :to="{ name: 'works' }" class="backBtn">
            <img src="@/assets/images/@ico_back_x2.jpg" alt="" />
            <span>Back to list</span>
          </router-link>
        </div>
      </div>

      <router-link v-if="true" :to="{ name: 'works-TrueEtn' }" class="longEnd vType">
        <div class="viewType">
          <span>next</span>
          <strong class="web">한국투자증권 TRUE ETN 웹사이트 개편</strong>
          <strong class="mobile">한국투자증권 <br />TRUE ETN 웹사이트 개편</strong>
        </div>

        <div class="engBg TrueEtnEndBg">
          <span />
        </div>
      </router-link>
    </div>

    <footer-area />
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import HeaderArea from "@/components/Header";
import FooterArea from "@/components/Footer";
import common from "@/shared/mixin/common.js";
import MarqueeText from "vue-marquee-text-component";
import VueKinesis from "vue-kinesis";
Vue.use(VueKinesis);

export default {
  mixins: [common],
  name: "Main",
  /* head: {
    title: {
      inner: '삼성웰스토리'
    }
  }, */
  head: {
    title: function() {
      return {
        inner: this.meta.title
      };
    },
    meta: function() {
      return [
        {
          name: "description",
          content: this.meta.desc
        },
        {
          name: "keywords",
          content: this.meta.keywords
        },
        // Open Graph
        { property: "og:title", content: this.meta.title },
        { property: "og:description", content: this.meta.desc },
        { property: "og:type", content: "website" },
        { property: "og:url", content: this.meta.url },
        { property: "og:image", content: this.meta.img },

        // Additional OG tags
        { property: "og:site_name", content: this.meta.siteName }
      ];
    }
  },
  components: {
    HeaderArea,
    FooterArea,
    MarqueeText
  },
  data() {
    return {
      meta: {
        siteName: "삼성웰스토리 STORY-G | 플립커뮤니케이션즈",
        title: "삼성웰스토리 STORY-G",
        desc:
          "삼성웰스토리 미디어 플랫폼은 식문화에 대한 관심 증가와 푸드 서비스 시장의 확장에 대응하여 만든 새로운 형태의 미디어 플랫폼입니다. 이 플랫폼을 통해 삼성웰스토리의 다양한 콘텐츠와 정보를 누구나 쉽고 편하고 재미있게 접할 수 있으며, 트렌디한 식사 문화를 바탕으로 건강과 삶의 질 향상에 기여합니다.",
        keywords:
          "삼성웰스토리, 미디어 플랫폼, 푸드 서비스, 시장 동향, 식문화, 건강한 라이프스타일, 브랜드 아이덴티티, 트렌드, 다양한 형태, 확장, 유용한 정보, 미디어 컨텐츠, 플랫폼 구축, 캠페인, 콘텐츠 디자인",
        url: "https://www.pulip.com/works/SamsungWells",
        img: "https://www.pulip.com/pulip-logo.jpg"
      },
      W: 0,
      icoInter: null,
      icoVal: 0
    };
  },
  computed: {
    ...mapState("common", {
      readyAction: state => state.readyAction,
      startProjectPop: state => state.startProjectPop,
      recruitPop: state => state.recruitPop,
      awardsPop: state => state.awardsPop,
      culturePop: state => state.culturePop,
      navigation: state => state.navigation
    }),
    W2() {
      return this.W / 2;
    },
    W3() {
      return this.W / 3;
    },
    W4() {
      return this.W / 4;
    }
  },
  methods: {
    doCopy() {
      this.$copyText("https://www.pulip.com/sns/samsungLife").then(
        function(e) {
          alert("복사되었습니다.");
          console.log(e);
        },
        function(e) {
          console.log(e);
        }
      );
    },
    handleResize() {
      this.W = window.innerWidth;
      this.H = window.innerHeight;
    },
    visibilityChanged(isVisible, entry) {
      // this.isVisible = isVisible
      console.log(entry);
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    this.sec1Slider.destroy();
    this.sec2Slider.destroy();
    this.sec3Slider.destroy();
    this.sec4Slider.destroy();
    this.sec5Slider.destroy();
    window.removeEventListener("resize", this.handleResize);
    clearInterval(this.icoInter);
  },
  mounted() {
    this.sec1Slider = new window.Swiper(".ssWellsKeyword .swiper-container", {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      loop: true,
      slidesPerView: "auto",
      spaceBetween: 30,
      speed: 1000,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false
      }
    });
    this.sec2Slider = new window.Swiper(".ssWellsStory .swiper-container", {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      loop: true,
      slidesPerView: "auto",
      centeredSlides: true,
      spaceBetween: 30,
      speed: 1000,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false
      },
      breakpoints: {
        891: {
          spaceBetween: 60
        }
      }
    });
    this.sec3Slider = new window.Swiper(".storySwiper.swiper-container", {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      loop: true,
      slidesPerView: 3,
      speed: 1000,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false
      }
    });
    this.sec4Slider = new window.Swiper(".mediaSwiper.swiper-container", {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      loop: true,
      slidesPerView: 4,
      speed: 1000,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false
      }
    });
    this.sec5Slider = new window.Swiper(".swiperSearch.swiper-container", {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      loop: true,
      slidesPerView: "auto",
      speed: 1000,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false
      }
    });
  }
};
</script>
